import MuiInputAdornment, {
  InputAdornmentProps
} from '@mui/material/InputAdornment';

export interface IInputAdornmentProps extends InputAdornmentProps {}

const InputAdornment = (props: IInputAdornmentProps): JSX.Element => {
  return <MuiInputAdornment {...props} />;
};

export default InputAdornment;
